import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    removeAll: translate({ id: 'order.form.bulk.tags.removeAll' }),
    moreTooltip: translate({ id: 'order.form.bulk.tags.moreTooltip' }),
    deleteAllTagsDisabledTooltip: translate({
      id: 'order.form.bulk.tags.deleteAllTagsDisabledTooltip',
    }),
  }))

  return api
}
